import { useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from "components/header";
import { GlobalContext } from "./contexts/global-context";
import VolksVale from "pages/volks-vale";
import Premios from "pages/premios";
import ModalAuth from "components/modal-auth";
import Regulamento from "pages/regulamento";
import Faq from "pages/faq";

export default () => {
    const [userName, setUserName] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const globalContextValue = {
        userName,
        setUserName,
    };
    return (
        <GlobalContext.Provider value={globalContextValue}>
            <Router>
                <Header isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                <Switch>
                    <Route exact={true} path="/">
                        <VolksVale isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                    </Route>
                    <Route exact={true} path="/premios">
                        <Premios isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                    </Route>
                    <Route exact={true} path="/regulamento">
                        <Regulamento isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                    </Route>
                    <Route exact={true} path="/faq">
                        <Faq isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
                    </Route>
                </Switch>
                <ModalAuth isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            </Router>
        </GlobalContext.Provider>
    );
};
